export default {
  Profiles: {
    Number: 'شماره پروفیل',
    Name: 'نام پروفیل',
    Status: 'وضعیت',
    Add: 'افزودن پروفیل',
    Edit: 'ویرایش پروفیل',
    Delete: 'حذف پروفیل',
    Placeholder: {
      Name: 'لطفا نام پروفیل را وارد کنید. ',
    },
  },
}
